"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zonedDateTime = void 0;
const core_1 = require("@js-joda/core");
const zod_1 = require("zod");
const zonedDateTime = (parameters) => zod_1.z.union([
    zod_1.z.custom(value => value instanceof core_1.ZonedDateTime),
    zod_1.z.string().refine(value => {
        try {
            core_1.ZonedDateTime.parse(value, parameters === null || parameters === void 0 ? void 0 : parameters.dateTimeFormatter);
            return true;
        }
        catch (_a) {
            return false;
        }
    }, 'Invalid zoned date time').transform(value => core_1.ZonedDateTime.parse(value, parameters === null || parameters === void 0 ? void 0 : parameters.dateTimeFormatter))
]);
exports.zonedDateTime = zonedDateTime;
//# sourceMappingURL=ZodJodaZonedDateTime.js.map